import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import type { RegistryApproval } from '../../api/registryApiTypes';
import { StatusChip } from '../../ui/primitives';

/** Approve / reject for a pending request (server's canDecide decides), else its status. */
export default function ApprovalDecisionControls({
  approval,
  own,
  viewerCanApprove,
  onDecide,
}: {
  approval: RegistryApproval;
  own: boolean;
  viewerCanApprove: boolean;
  onDecide: (approve: boolean) => void;
}) {
  if (approval.status !== 'PENDING') {
    return <StatusChip status={approval.status} />;
  }
  return (
    <>
      <Stack direction="row" spacing={1}>
        <Button
          size="small"
          color="error"
          variant="outlined"
          disabled={!approval.canDecide}
          onClick={() => onDecide(false)}
        >
          Reject
        </Button>
        <Button
          size="small"
          variant="contained"
          disabled={!approval.canDecide}
          onClick={() => onDecide(true)}
        >
          Approve
        </Button>
      </Stack>
      {own && (
        <Typography variant="caption" color="warning.main">
          You raised this, so someone else must decide it
        </Typography>
      )}
      {!own && !viewerCanApprove && (
        <Typography variant="caption" color="text.secondary">
          Deciding needs the Registry Approval permission
        </Typography>
      )}
    </>
  );
}
